import React from 'react';
import { isLiveScorer, isLessThanAnHour } from '../../../helpers';
import { Fab, Icon } from 'react-onsenui';

const AddActionButton = props => {
    return (
        <div className='ls_add_action_btn'>
            {
                (isLiveScorer([props.live]) && props.pageReducer === 'upcomingMatch') &&
                <Fab 
                    modifier='ls_fab_add' 
                    position='bottom right'
                    onClick={props.onClick}
                    disabled={!isLessThanAnHour(props.match.date)}
                >
                    <Icon icon='md-plus' size={26} />
                </Fab>
            }
        </div>
    )
}

export default AddActionButton;